import Layout1 from "./pages/Layout1/Layout_1";

const routes = [
  { path: "/", component: <Layout1/> },
];

export default routes;